<template>
  <component
    :is="headlineTag"
    :class="['headline-fi', `fi-text-size-df-${size}`, colorClass]"
  >
    <slot>
      <!-- eslint-disable vue/no-v-html -->
      <template v-if="html">
        <span v-html="html" />
      </template>
      <!-- eslint-enable vue/no-v-html -->
    </slot>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { RichTextField, SingleLineTextField } from '@/sitecoreFieldTypes';
import colors from '@/tailwind/colors';

defineOptions({
  name: 'HeadlineFi',
});

interface Props {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h7' | 'h8' | 'h9' | 'div' | 'span' | '';
  size?: number;
  field?: SingleLineTextField | RichTextField | null;
  htmlContent?: string;
  color?: string;
}

const props = withDefaults(defineProps<Props>(), {
  tag: '',
  size: 48,
  field: null,
  htmlContent: undefined,
  color: '',
});

const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7', 'h8', 'h9', 'div', 'span'];

const colorClass = computed(() => {
  const colorValue = colors.typo[props.color] ? props.color : 'black';
  return `fi-text-${colorValue}`;
});

const html = computed(() => {
  if (props.htmlContent) {
    return props.htmlContent;
  }
  if (!props.field) {
    return null;
  }
  return props.field.editable || props.field.value;
});

const headlineTag = computed(() => {
  let tag = 'h2';

  if (allowedTags.includes(props.tag)) {
    tag = props.tag;
  }

  return tag;
});
</script>

<style scoped src="./headline-fi" />
